export const resumoItemStyle = {}
